import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .recharts-tooltip-wrapper {
    z-index: 1000;
  }
`;

export const Card = styled.div`
	width: Fixed (204px) px;
	height: Fill (207px) px;
	padding: 14px;
	padding-bottom: 0;
	border-radius: 6px;
	border: 1px 0px 0px 0px;
	justify-content: space-between;
	opacity: 0px;
	border: 1px solid #dee2e6;
`;

export const CardTitle = styled.div`
	font-size: 17.5px;
	font-weight: 500;
	line-height: 26px;
	text-align: left;
`;

export const CardSubtitle = styled.div`
	font-size: 11px;
	font-weight: 400;
	line-height: 18px;
	text-align: left;
	color: #6c757d;
	margin-bottom: 24px;
`;
